import { cssVar } from '@cad-arc';
import { EntityTypes, MergedEntityTypes } from '../../../../fr-entity-panels/types';

export const CARD_CONTAINERS_PADDING = cssVar('arc.space.3');

export const UNKNOWN_ENTITIES_CARDS_LABELS = {
    [EntityTypes.INVOLVED_PERSONS]: 'Involved Person',
    [EntityTypes.REPORTING_PARTIES]: 'Reporting Party',
    [EntityTypes.VEHICLES]: 'Vehicle',
    [EntityTypes.TOW_VEHICLES]: 'Tow Vehicle',
    [EntityTypes.FIREARMS]: 'Firearms',
    [EntityTypes.DRUGS]: 'Drugs',
    [EntityTypes.OTHER_ITEMS]: 'Other Items',
    [MergedEntityTypes.INVOLVED_PERSONS]: 'Merged Involved Person',
    [MergedEntityTypes.REPORTING_PARTIES]: 'Merged Reporting Party',
    [MergedEntityTypes.VEHICLES]: 'Merged Vehicle',
    [MergedEntityTypes.TOW_VEHICLES]: 'Merged Tow Vehicle',
    [MergedEntityTypes.FIREARMS]: 'Merged Firearms',
    [MergedEntityTypes.DRUGS]: 'Merged Drugs',
    [MergedEntityTypes.OTHER_ITEMS]: 'Merged Other Items',
};
